import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  ROUTE_GRANT_OPPORTUNITIES,
  ROUTE_GRANT_OPPORTUNITIES_DETAILS,
  ROUTE_GRANT_OPPORTUNITY_DOCUMENT_PREVIEW,
  SCOPE_GRANT_OPPORTUNITIES,
} from '../../constants';
import { AddToPipelineConsumer, AddToPipelineProvider } from '../../contexts/AddToPipelineContext';
import Suspense from '../../services/lazyLoad/Suspense';

const GrantOpportunities = React.lazy(() => import('./GrantOpportunities'));
const GrantOpportunitiesDetails = React.lazy(() => import('./GrantOpportunityDetails'));
const GrantOpportunityDocumentPreview = React.lazy(() => import('./GrantOpportunityDocumentPreview'));

export default function GrantOpportunitiesWrapper() {
  return (
    <Suspense>
      <AddToPipelineProvider scope={SCOPE_GRANT_OPPORTUNITIES}>
        <Switch>
          <Route exact path={ROUTE_GRANT_OPPORTUNITY_DOCUMENT_PREVIEW.path}>
            <GrantOpportunityDocumentPreview />
          </Route>
          <Route exact path={ROUTE_GRANT_OPPORTUNITIES_DETAILS.path}>
            <GrantOpportunitiesDetails />
          </Route>
          <Route exact path={ROUTE_GRANT_OPPORTUNITIES.path}>
            <GrantOpportunities />
          </Route>

          <Redirect exact path="/*" to={ROUTE_GRANT_OPPORTUNITIES.path} />
        </Switch>

        <AddToPipelineConsumer />
      </AddToPipelineProvider>
    </Suspense>
  );
}
